'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaybeSalesVerified = undefined;
exports.hasSalesExtensionParams = hasSalesExtensionParams;
exports.isVerifiedFlow = isVerifiedFlow;
exports.getExplicitFlowPathForVerificationOnCrmEndpoint = getExplicitFlowPathForVerificationOnCrmEndpoint;

var _params = require('hub-http/helpers/params');

var _immutable = require('immutable');

var _isFunnel = require('../core/utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _frame = require('../core/utils/frame');

var _AppConfigContainer = require('../core/globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _SignupFlows = require('signup-ui-core/constants/SignupFlows');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
function getQueryParams() {
  var queryString = window.location.search;
  var params = (0, _immutable.Map)();
  if (queryString.length) {
    var queryParams = (0, _params.parse)(queryString.substring(1));
    params = (0, _immutable.Map)(queryParams);
  }
  return params;
}

//based on: https://git.hubteam.com/HubSpot/SalesExtensionRemoteAssets/blob/edbf581fedd0842cf2fee0c6a7d50032195b9545/static/js/apis/hubspotUrlBuilders.js#L45-L52
function hasGmailParams() {
  var params = getQueryParams();
  if (params) {
    var utmMedium = params.get('utm_medium');
    var optSidebar = params.get('opt_sidebar');
    return utmMedium === 'marketplaces' && optSidebar === 'sales-extension-signup';
  }
  return false;
}

//based on: https://git.hubteam.com/HubSpot/SalesOffice365AddIn/blob/8e86a891df6e83905a5022beffc941aa308eff9a/static/js/data/UrlBuilders.js#L51-L58
function hasO365Params() {
  var params = getQueryParams();
  if (params) {
    var utmSource = params.get('utm_source');
    var utmCampaign = params.get('hubs_campaign');
    var intent = params.get('intent');
    return utmSource === 'microsoft' && utmCampaign === 'office-web-store' && intent === 'salesO365';
  }
  return false;
}

function hasVstoParams() {
  var params = getQueryParams();
  if (params) {
    var utmSource = params.get('utm_source');
    var intent = params.get('intent');
    return utmSource === 'outlook-desktop-client' && intent === 'salesVsto';
  }
  return false;
}

function hasSalesExtensionParams() {
  return hasGmailParams() || hasO365Params() || hasVstoParams();
}

var getMaybeSalesVerified = exports.getMaybeSalesVerified = function getMaybeSalesVerified() {
  return hasSalesExtensionParams() ? import( /* webpackChunkName: "bundles/flow/sales" */'./standard/configs/sales') : import( /* webpackChunkName: "bundles/flow/sales" */'./standard/configs/verified/sales');
};

function isVerifiedFlow() {
  return (
    //with the verified prop the following checks might be redundant, kept for safety and to handle exceptions.
    (0, _isFunnel.verified)() && (_isFunnel2.default.service() || _isFunnel2.default.crm() || _isFunnel2.default.marketing() && !_isFunnel2.default.wordpress() || _isFunnel2.default.sales() && !hasSalesExtensionParams() || _isFunnel2.default.academy() && !_isFunnel2.default.embeddedAcademy() || _isFunnel2.default.embeddedAllInOne() || _isFunnel2.default.integrations() || _isFunnel2.default.classroomTraining() || _isFunnel2.default.hubspotForStartups() || _isFunnel2.default.trial())
  );
}

function embeddedCanonicalPath(baseHistoryPath) {
  if (baseHistoryPath.indexOf('-') > 0) {
    return baseHistoryPath.split('-')[1];
  }
  LOG.warn('Can\'t get canonical embedded flow path from' + baseHistoryPath + ' defaulting to CRM');
  return _SignupFlows.SignupFlowToPath.CRM;
}

function getExplicitFlowPathForVerificationOnCrmEndpoint() {
  var baseHistoryPath = _AppConfigContainer2.default.get('baseHistoryPath');
  return _isFunnel2.default.sales() || _isFunnel2.default.purchase() || _isFunnel2.default.integrations() || _isFunnel2.default.trial() || _isFunnel2.default.wordpress() || (0, _frame.isFramed)() ? _isFunnel2.default.embeddedAllInOne() ? embeddedCanonicalPath(baseHistoryPath) : baseHistoryPath : null;
}